import { useEffect, useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { Layout } from "ui-components/Layout";
import { Success, Error_ } from "ui-components/Alert";
import { formRender, initialValues, locationValidations } from "./location-schema";
import LocationInfo from "./components/LocationInfo";
import { useLocation } from "react-router-dom";
import { editLocation } from "services/data.internal.service";
import { SaveButton } from "ui-components/Form";
import { getLocation } from "services/data.internal.service";
import { useLocationGroupOptionsQuery } from "hooks/useLocationQuery";

function EditLocation() {
  const location = useLocation();
  const { warehouseCode, zoneID, locationID } = location?.state ?? {};

  const [locDimGrpOptions, setLocDimGrpOptions] = useState([]);

  const [alert, setAlert] = useState(null);
  const [formValues, setFormValues] = useState(null);
  const queryClient = useQueryClient();
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  useQuery({
    queryKey: ["location", { warehouseCode, zoneID, locationID }],
    queryFn: () => getLocation({ warehouseCode, zoneID, locationID }),
    onSuccess: (data) => setFormValues(data.data.data),
    onError,
  });

  const editLocationMutation = useMutation(editLocation, {
    onSuccess: (data) => {
      setAlert(<Success data={data} onChange={setAlert} />);
    },
    onError,
  });
  const form = useForm({
    defaultValues: initialValues,
    values: formValues,
    resolver: yupResolver(locationValidations),
  });

  const {
    getValues,
    control,
    handleSubmit,
    formState: { errors, isDirty, isSubmitting },
    setValue,
    watch,
    reset,
  } = form;

  useLocationGroupOptionsQuery({
    onSuccess: (data) => setLocDimGrpOptions(data.data.data),
  })

  const locCategory = watch("locCategory");

  useEffect(() => {
    if (locCategory === null) {
      setValue("dropZone", null);
    }
  }, [locCategory]);

  const infoProps = {
    mode: "EDIT",
    values: { locCategory },
    getValues,
    control,
    errors,
    setValue,
    formRender,
    locDimGrpOptions,
  };
  const onSubmit = (data) => { 
    window.scrollTo(0, 0);
    editLocationMutation.mutate(data, {
      onSuccess: () => queryClient.invalidateQueries(["location"])
    });
  };
  return (
    <Layout lg={12}>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <LocationInfo {...infoProps} />
        <SaveButton label="Save" disabled={!isDirty} url="/setup/location" />
      </form>
    </Layout>
  );
}

export default EditLocation;
